import { useMediaQuery } from '@hover/blueprint/chakra';
import { breakpoints } from '@hover/blueprint/foundation';

const useIsDesktopSize = (): boolean =>
  useMediaQuery(`(min-width: ${breakpoints?.desktop})`)[0];

export { useIsDesktopSize };
